import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectsGroupByTerms from "./routes/SubjectsGroupByTerms";
export default store => ({
  path: "assessment-categories",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "./modules/AssessmentCategoriesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "assessmentCategories",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SubjectsGroupByTerms(store)],
});
